// Simple dashboard password check.
// NOTE: For now this is a static password match. Replace with proper Lovable Cloud
// auth (email + password using supabase.auth) when ready.
import { supabase } from "@/integrations/supabase/client";

export const getDashboardPassword = (): string =>
  localStorage.getItem("dashboard_pw") || sessionStorage.getItem("dashboard_pw") || "";

export const dashboardApi = async (action: string, extra: Record<string, unknown> = {}) => {
  const { data, error } = await supabase.functions.invoke("dashboard-leads", {
    body: { password: getDashboardPassword(), action, ...extra },
  });
  if (error || data?.error) {
    const status = (error as any)?.context?.status;
    if (status === 401 || data?.error === "Unauthorized") {
      clearDashboardSession();
      window.location.reload();
    }
    throw error || new Error(data.error);
  }
  return data;
};

export const validateDashboardPassword = async (password: string): Promise<boolean> => {
  const { data, error } = await supabase.functions.invoke("dashboard-leads", {
    body: { password, action: "verify" },
  });
  if (error || !data?.ok) return false;
  sessionStorage.setItem("dashboard_pw", password);
  return true;
};

export const setDashboardSession = (rememberMe: boolean = false): void => {
  const storage = rememberMe ? localStorage : sessionStorage;
  const pw = sessionStorage.getItem("dashboard_pw") || "";
  storage.setItem("dashboard_pw", pw);
  storage.setItem("dashboard_access", "true");
  storage.setItem("dashboard_access_time", Date.now().toString());
};

export const clearDashboardSession = (): void => {
  localStorage.removeItem("dashboard_access");
  localStorage.removeItem("dashboard_access_time");
  sessionStorage.removeItem("dashboard_access");
  sessionStorage.removeItem("dashboard_access_time");
  localStorage.removeItem("dashboard_pw");
  sessionStorage.removeItem("dashboard_pw");
};

export const checkDashboardSession = (): boolean => {
  let hasAccess = localStorage.getItem("dashboard_access") === "true";
  let accessTime = parseInt(localStorage.getItem("dashboard_access_time") || "0");

  if (!hasAccess) {
    hasAccess = sessionStorage.getItem("dashboard_access") === "true";
    accessTime = parseInt(sessionStorage.getItem("dashboard_access_time") || "0");
  }

  if (hasAccess && !getDashboardPassword()) {
    clearDashboardSession();
    return false;
  }

  const SESSION_DURATION = 24 * 60 * 60 * 1000; // 24 hours
  if (hasAccess && Date.now() - accessTime > SESSION_DURATION) {
    clearDashboardSession();
    return false;
  }

  return hasAccess;
};
